import { Controller } from "@hotwired/stimulus";

export default class extends Controller {

  static get targets () {
    return [
      "primaryList",
    ];
  }
  
 connect() {
    $.uf.maxLength("#screening-questions", "textarea");      
    this.initializeSortable();
    this.listenForQuestionAddition();
    document.addEventListener("turbo:load", this.initializeSortable.bind(this));
    document.addEventListener("turbo:before-stream-render", this.initializeSortable.bind(this));
    this.setupCollapseListeners();
    this.observeMutations();
  }

setupCollapseListeners() {
  const observer = new MutationObserver((mutations) => {
    this.processMutations(mutations);
  });
  observer.observe(document.body, { childList: true, subtree: true });
  this.addCollapseListeners();
}

processMutations(mutations) {
  mutations.forEach((mutation) => {
    if (mutation.addedNodes.length) {
      this.addCollapseListeners();
    }
  });
}

addCollapseListeners() {
  const toggleLinks = document.querySelectorAll("[id^='toggle-link-']");
  toggleLinks.forEach((toggleLink) => {
    // Prevent re-adding listeners to the same element
    if (toggleLink.dataset.listenerAdded) {
      return;
    }

    const target = document.querySelector(toggleLink.getAttribute("href"));
    if (target) {
      $(target).on("shown.bs.collapse", function () {
        toggleLink.textContent = window.I18n["general.hide"];
      });

      $(target).on("hidden.bs.collapse", function () {
        toggleLink.textContent = window.I18n["general.options"];
      });

      // Check initial state
      if (target.classList.contains("in") || target.classList.contains("show")) {
        toggleLink.textContent = window.I18n["general.hide"];
      } else {
        toggleLink.textContent = window.I18n["general.options"];
      }
    }

    // Mark this element as processed
    toggleLink.dataset.listenerAdded = true;
  });
}

  listenForQuestionAddition() {
    var controlTypeSelect = document.getElementById("control_type_select");
    if (controlTypeSelect) {
      controlTypeSelect.addEventListener("change", function() {
        var selectedControlType = this.value;
        var link = document.getElementById("link_" + selectedControlType);
        if (link) {
          link.click();
          this.value = "";
        }
      });
    }
  }

  initializeSortable() {
    $( this.primaryListTarget ).sortable({
      update: (event, ui) => {
        this.updateIndex();
      }
    });
  }

  updateIndex() {
    const items = this.primaryListTarget.querySelectorAll(".fields");
    items.forEach((element, index) => {
      const hiddenField = element.querySelector("input[name*='[order]']");
      if (hiddenField) {
        hiddenField.value = index;
      }
    });
  }

  observeMutations() {
    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === "childList") {
          this.handleChildListMutation();
        }
      }
    });
    observer.observe(this.primaryListTarget, { childList: true, subtree: true });
  }

  handleChildListMutation() {
    this.initializeSortable();
    this.updateLastDivOrder();
  }

  updateLastDivOrder() {
    const turboFrame = document.querySelector("#job_screening_questions");
    if (turboFrame) {
      const cfdDivs = turboFrame.querySelectorAll(".custom-field-definition-key[data-job-form-data-target]");
      let divCount = cfdDivs.length;
      const lastDiv = cfdDivs[divCount - 1];
      if (lastDiv) {
        const input = lastDiv.parentElement.querySelector("input[name*='[order]']");
        if (input) {
          input.value = divCount - 1;
        }
      }
    }
  }
}